import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query — single shared client.
 *
 * - staleTime tuned per-query in hooks (products 2 min, detail 5 min, cart 30s)
 * - retry skipped on 4xx so auth/permission errors fail fast
 * - refetchOnWindowFocus disabled — too aggressive for an ecommerce SPA
 */

function shouldRetry(failureCount: number, error: unknown): boolean {
  // Don't retry on 4xx — these are usually auth/permission/validation issues
  // that retrying won't fix.
  const status =
    error && typeof error === 'object' && 'response' in error
      ? (error as { response?: { status?: number } }).response?.status
      : undefined;

  if (typeof status === 'number' && status >= 400 && status < 500) {
    return false;
  }
  return failureCount < 2;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // 1 minute baseline; per-query overrides win
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: shouldRetry,
    },
    mutations: {
      retry: false,
    },
  },
});
